










import Vue from 'vue';

export default Vue.extend({
  name: 'HubSwitch',

  inheritAttrs: false,

  props: {
    value: {
      type: [Boolean, Number],
      required: true,
    },
  },

  computed: {
    switchState: {
      get() { return (this as any).value; },
      set(newValue) { return this.$emit('input', newValue); },
    },
  },
});
